var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBagging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    rx: 20,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.6826 70L71.7539 82.1641L81.5665 87.0555L107.04 74.5052L97.6826 70ZM80.0076 91.0463L70 86.1549V111.77L95.6038 124.514L94.564 98.2547L84.1665 93.0415V98.8983C84.1665 100.958 82.6719 101.194 82.152 101.151C80.6574 101.028 80.0076 100.1 80.0076 98.8983V91.0463ZM86.375 89.4382L97.4223 94.7157L122.831 82.2298L111.459 76.7592L86.375 89.4382ZM123.605 84.5103L98.3721 97.0872L98.6972 103.052C105.096 92.5751 117.968 93.111 123.605 94.6886V84.5103ZM129.999 114.741C129.999 123.168 123.102 130 114.593 130C106.083 130 99.1855 123.168 99.1855 114.741C99.1855 106.314 106.083 99.4819 114.593 99.4819C123.102 99.4819 129.999 106.314 129.999 114.741ZM121.511 113.013V115.983H116.215V121.938H112.984V115.983H107.674V113.013H112.984V107.428H116.215V113.013H121.511Z",
    fill: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBagging);
export default __webpack_public_path__ + "static/media/noBagging.cbce70cc785f6caf9542a5fcdb627dd3.svg";
export { ForwardRef as ReactComponent };